import { DocumentType } from './document-type'

interface IDocumentModel {
  type: DocumentType.Enum
  value?: string | null
}

export interface DeprecatedDocumentModel extends IDocumentModel {}

export class DocumentModel implements IDocumentModel {
  constructor(
    public readonly type: DocumentType.Enum,
    public readonly value?: string | null
  ) {}

  public get hiddenValue(): string {
    return this.type.hide(this.value ?? '')
  }

  public static create(documentResponse: DocumentResponse | null): DocumentModel {
    return new DocumentModel(
      DocumentType.getByValue(documentResponse?.type)!,
      documentResponse?.value
    )
  }
}

export interface DocumentResponse {
  type: string
  value: string
}
